import $ from 'jquery';

class CounterUp {
    constructor(element) {
        this.element = element;
        this.animationDuration = 4000;
        this.value = 0;
        this.decimals = 0;
        this.suffix = '';
        this.init();
    }

    async init() {
        this.value = parseFloat(this.element.innerHTML);
        if (!this.value) return;
        this.decimals = this.countDecimals(this.value);
        this.element.textContent = this.value;
        this.element.style.width = await this.getElementWidth();
        this.element.textContent = 0;
        $('.statistics__grid__item').on('playAnimation', () => {
            this.animate();
        });
    }

    getElementWidth() {
        return new Promise((resolve) => {
            setTimeout(() => {
                const width = this.element.getBoundingClientRect().width;
                // console.log(width);
                resolve(`${width.width}px`)
            }, 0);
        })
    }

    commaSeparateNumber(val) {
        while (/(\d+)(\d{3})/.test(val.toString())) {
            val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }
        return val;
    }

    animate = () => {
        let startTime = null;
        let currentTime = Date.now();
        const step = (currentTime) => {
            if (!startTime) {
                startTime = currentTime;
            }
            const progress = Math.min((currentTime - startTime) / this.animationDuration, 1);

            if (this.decimals > 0) {
                this.element.innerHTML = Math.floor(progress * this.value * Math.pow(10, this.decimals)) / Math.pow(10, this.decimals) + this.suffix;
            } else {
                this.element.innerHTML = this.commaSeparateNumber(Math.floor(progress * this.value)) + this.suffix;
            }

            if (progress < 1) {
                window.requestAnimationFrame(step);
            } else {
                window.cancelAnimationFrame(window.requestAnimationFrame(step));
            }
        };

        window.requestAnimationFrame(step);
    };

    countDecimals = (v) => {
        if (Math.floor(v) === v) return 0;
        return v.toString().split(".")[1].length || 0;
    };
}

export default function useCounterUpAnimator() {
    const counterInstances = [];
    for (const counterElement of document.querySelectorAll('.counter-animator')) {
        // console.log(counterElement)
        const counterInstance = new CounterUp(counterElement);
        counterInstances.push(counterInstance);
    }
    return counterInstances;
}
